// 选择产品组件
<template>
  <el-dialog
    :visible.sync="visible"
    title="选择产品"
    width="1080px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="handleClose"
  >
    <div class="select-wechat-container">
      <div class="left-panel">
        <el-form ref="form" :model="params" inline>
          <el-form-item>
            <el-input
              placeholder="请输入关键词"
              v-model.trim="params.keyWord"
              clearable
              @clear="searchBtn"
            >
              <el-select
                v-model="params.keyType"
                slot="prepend"
                placeholder="请选择"
                style="width: 150px"
              >
                <el-option
                  v-for="(item, index) in keywordTypeArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-s-table
          ref="table"
          :columns="columns"
          :data="list"
          row-key="id"
          @select="handleSelect"
          @select-all="handleSelectALL"
        />
        <div class="pagebox" v-if="total > pageSize">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>
      <div class="vertical-divider" />
      <div class="right-panel">
        <div class="selected-title">已选择（{{ selectedRows.length }}）</div>
        <div class="selected-list">
          <div class="item-tag" v-for="item in selectedRows" :key="item.id">
            <el-tag closable @close="handleTagClose(item)">
              {{ item.productName }}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getGuanYiProductList,
  getGuanYiProductDetails,
} from "@/api/hxl/public";
export default {
  name: "SelectGoods",
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keywordTypeArr: [
        {
          label: "产品名称",
          value: "productName",
        },
        {
          label: "管易云商品代码",
          value: "gyuProductCode",
        },
      ],
      visible: false,
      params: {
        keyWord: undefined,
        keyType: "productName",
      },
      selectedRows: [],
      list: [],
      columns: [
        {
          type: "selection",
          "reserve-selection": true,
          selectable: (row, index) => {
            return (
              this.multiple ||
              this.selectedRows.length <= 0 ||
              this.selectedRows.find((item) => item.id == row.id)
            );
          },
        },
        {
          label: "产品名称",
          prop: "productName",
        },
        {
          label: "管易云商品代码",
          prop: "gyuProductCode",
        },
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      initSelectedRows: [],
    };
  },
  methods: {
    handleTagClose(closedItem) {
      let removeItem = this.list.find((item) => item.id === closedItem.id);
      if (!removeItem) {
        removeItem = this.selectedRows.find(
          (item) => item.id === closedItem.id
        );
      }
      this.$refs.table.toggleRowSelection(removeItem, false);
      this.selectedRows = this.selectedRows.filter(
        (item) => item.id !== closedItem.id
      );
    },
    showDialog(selectedRows = []) {
      this.visible = true;
      this.initSelectedRows = selectedRows || [];
      this.initData();
    },
    async initData() {
      for (let i = 0; i < this.initSelectedRows.length; i++) {
        this.getInfo(this.initSelectedRows[i]);
      }
      this.searchBtn();
    },
    handleClose() {
      this.$refs.table.clearSelection();
      this.selectedRows = [];
    },
    searchBtn() {
      this.page = 1;
      this.getList();
    },
    async getList() {
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        ...this.params,
      };
      if (params.keyWord && params.keyType) {
        params[params.keyType] = params.keyWord;
      }
      delete params.keyWord;
      delete params.keyType;
      const { code, data, message } = await getGuanYiProductList(params);
      if (code == 200) {
        const { data: list, total } = data;
        this.list = list;
        this.total = total;
        this.$nextTick(() => {
          this.list.forEach((item) => {
            this.$refs.table.toggleRowSelection(item, false);
            this.initSelectedRows.forEach((id) => {
              if (item.id === id) {
                this.$refs.table.toggleRowSelection(item, true);
              }
            });
          });
        });
      }
    },
    async getInfo(productTId) {
      const { code, data, message } = await getGuanYiProductDetails({
        productTId,
      });
      if (code == 200) {
        this.selectedRows.push({ productName: data.productName, id: data.id });
        return;
      }
    },
    handleConfirm() {
      this.$emit("confirm", JSON.parse(JSON.stringify(this.selectedRows)));
      this.visible = false;
    },
    handleSelect(selection, row) {
      if (selection?.some((item) => item.id === row.id)) {
        // 勾选时，如果不在已选择列表中，则添加到已选择列表
        if (!this.selectedRows.some((item) => item.id === row.id)) {
          this.selectedRows = [...this.selectedRows, row];
        }
      } else {
        // 取消勾选时，如果还在已选择列表中，则从已选择列表移除
        this.selectedRows = this.selectedRows.filter(
          (item) => item.id !== row.id
        );
      }
    },
    handleSelectALL(val) {
      if (!this.multiple) return;
      let temp = JSON.parse(JSON.stringify(this.selectedRows));
      const curListIdMap = new Map();
      this.list.forEach((item) => {
        curListIdMap.set(item.id, item);
      });
      temp = temp.filter((item) => !curListIdMap.has(item.id));
      // 全选时，如果不在已选择列表中，则添加到已选择列表
      if (this.selectedRows.length - temp.length !== this.list.length) {
        temp = [...temp, ...this.list];
      }
      this.selectedRows = JSON.parse(JSON.stringify(temp));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.select-wechat-container {
  display: flex;
  height: 550px;
}

.left-panel {
  flex: 1;
  padding-right: 15px;
  overflow: auto;
}

.right-panel {
  flex: 0 0 260px;
  padding-left: 15px;
}

.vertical-divider {
  width: 1px;
  background-color: #dcdfe6;
  margin: 0 15px;
}

.selected-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}

.selected-list {
  max-height: 100%;
  overflow: auto;
  .item-tag {
    margin-bottom: 10px;
  }
}

.pagebox {
  margin-top: 10px;
}
</style>
